var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",class:{ 'tracking-wider': _vm.isCustomFont }},_vm._l((_vm.preparedLabelArray),function(item,index){return _c('span',{key:index},[(item.type === 'text')?[_vm._v(_vm._s(item.content))]:_vm._t("default")],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }